import "./Chat.scss"
import ChatInput from "../ChatInput/ChatInput"
import ChatWindow from "../ChatWindow/ChatWindows"
import { useEffect, useState } from "react"
import { IChatOption, IMessage } from "../../../../shared/models/chat_models"
import { ChatOptionEnum } from "../../chat-models"
import { BaseMapFilterEnum } from "../../../../shared/models/map_models"


interface IChatProps {
    sendQuery: (query: string) => void
    loading: boolean
    messages: Array<IMessage>,
    chatOptions: Array<IChatOption>,
    selectedChatType: string,
    setSelectedChatType: (chatType: string) => void
}

const Chat = (props: IChatProps) => {

    const [chatOptions, setChatOptions] = useState<Array<IChatOption>>([])

    useEffect(() => {
        setChatOptions(props.chatOptions)
    }, [props.chatOptions])

    const chatOptionSelected = (selectedOption: IChatOption, radioIndex?: number) => {
        if(selectedOption.type === 'button'){
            const chatOptionCopy = [...chatOptions]
            chatOptionCopy.forEach((option) => {
                if (option.name === selectedOption.name)
                    option.checked = !option.checked
            })
            setChatOptions(chatOptionCopy)
        } else if(selectedOption.type === BaseMapFilterEnum.RADIO && radioIndex !== undefined && selectedOption.radioOptions){
            if (selectedOption.name === ChatOptionEnum.CHAT_TYPE){
                props.setSelectedChatType(selectedOption.radioOptions[radioIndex].value)
            }
        }
    }

    return (
        <div className="chat-wrapper">
            <ChatWindow 
                messages={props.messages} 
                loading={props.loading}
                chatOptions={chatOptions}
            />
            <ChatInput 
                sendQuery={props.sendQuery} 
                loading={props.loading} 
                messages={props.messages}
                chatOptions={chatOptions}
                chatOptionSelected={chatOptionSelected}
                selectedChatType={props.selectedChatType}
            />
        </div>
    )
}

export default Chat